import { Component, ElementRef, HostBinding, Input, OnInit, OnChanges, Renderer2, SimpleChanges } from "@angular/core";
import { GridWidth } from "@spscommerce/ds-shared";

@Component({
    selector: "sps-grid-col",
    template: `<ng-content></ng-content>`
})
export class SpsGridColComponent implements OnInit, OnChanges {
    @Input() width: GridWidth;

    @HostBinding("class.d-none") get zeroWidth() {
        return this.width === 0;
    }

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    ngOnInit() {
        this.renderer.addClass(this.elementRef.nativeElement, `col-${this.width}`);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.renderer.removeClass(this.elementRef.nativeElement, `col-${changes.width.previousValue}`);
        this.renderer.addClass(this.elementRef.nativeElement, `col-${changes.width.currentValue}`);
    }
}
